import CommentModal from "./FeedBackModal";

export default CommentModal;
